import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";

export const fetchTrashedBets = createAsyncThunk(
  "trashedBets/fetchTrashedBets",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/bets/trashed-bets/${userId}`);
      console.log("API response:", res.data); 
      return res.data;
    } catch (err) {
    
      return rejectWithValue(
        err.response?.data || { message: "Failed to fetch trashed bets" }
      );
    }
  }
);

const trashedBetsSlice = createSlice({
  name: "trashedBets",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrashedBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrashedBets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTrashedBets.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Error fetching trashed bets";
      });
  },
});

export default trashedBetsSlice.reducer;
